import React from 'react';
import { Link } from 'react-router-dom';

function Breadcrumb({ items = [] }) {
  if (!items.length) return null;

  return (
    <nav className="hr-breadcrumb" aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="hr-breadcrumb-item">
            {index > 0 && <span className="hr-breadcrumb-sep">›</span>}
            {isLast || !item.path ? (
              <span className="hr-breadcrumb-current">{item.label}</span>
            ) : (
              <Link to={item.path}>{item.label}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}

export default Breadcrumb;
